<template>
  <div>
    <cube-tab-bar
      v-model="activeBlocks.selectedLabel"
      show-slider
      @change="clickHandler"
    >
      <cube-tab
        v-for="(item, index) in activeBlocks.tabs"
        :label="item.label"
        :key="index"
        class="subject_tab"
      ></cube-tab>
    </cube-tab-bar>
    <cube-tab-panels v-model="activeBlocks.selectedLabel">
      <cube-tab-panel
        v-for="(item, index) in activeBlocks.tabs"
        :label="item.label"
        :key="index"
      >
        <ul class="subject-tab-wrapper" @click="routerEquity">
          <li
            v-for="(tip, j) in item.heroes"
            :key="j"
            :data-status="tip.status"
            :data-link="tip.url"
          >
          <!-- <img :src="tip.image" alt /> -->
          <!-- <p >{{ tip.text }}</p> -->
            <img :src="tip.image" :class="{ big: tip.class , big_c:tip.class_c}"    alt />
            
            <div class="subject-tab-text-box">
              <template v-if="isArray(tip.text)">
                <p v-for="(item, index) in tip.text" :key="index">{{ item }}</p>
              </template>
              <p v-else>{{ tip.text }}</p>
            </div>
          </li>
        </ul>
      </cube-tab-panel>
    </cube-tab-panels>
  </div>
</template>

<script>
export default {
  props: {
    activeBlocks: {
      type: Object,
      default() {
        return {
          selectedLabel: "",
          tabs: [],
        };
      },
    },
    dataName: String,
  },
  data() {
    return {};
  },
  methods: {
    RouterPush(params) {
      this.$router.push({ name: params.name, params: { ...params } });
    },
    routerEquity(e) {
      let targetnodeli;
      if(e.target.nodeName == 'P'){
        targetnodeli = e.target.parentNode.parentNode;
      }else{
        targetnodeli = e.target.parentNode;
      }
      console.log(targetnodeli.dataset.link)
      if((targetnodeli.dataset.link).indexOf('http') !== -1){
        return window.location.href = targetnodeli.dataset.link
      }
      if (targetnodeli.nodeName === "LI") {        
        let link = targetnodeli.dataset.link;      
        let status =targetnodeli.dataset.status;
        
        let path = link.split(/\//g);
        let name = path[0];
        let equity = path[1];
        let id = path[2];
        if (status !== "true") {
          this.RouterPush({ name, equity, id });
        }
      }
    },
    isArray(object) {
      return Object.prototype.toString.call(object) === "[object Array]";
    },
    clickHandler(label) {
      //this.$store.dispatch('setTabName',{name:this.dataName,value:label})
    },
  },
};
</script>

<style lang="scss" scoped>
</style>